import {Component, OnInit} from '@angular/core';
import {LogLevel, LogResource, ViewportTab} from '@app/modules/shared/data/constants';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {LogService} from '@app/services/log.service';
import {ReportAction, ReportState, ReportStateModel} from '@app/state/report.state';


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html'
})
export class ReportComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public ViewportTab = ViewportTab;
  public classroom: ClassroomStateModel;
  public report: ReportStateModel;
  public url: string;
  public safeURL: SafeResourceUrl;

  constructor(
    public sanitizer: DomSanitizer,
    private store: Store,
  ) {
    this.listenStoreChanges();
  }

  public ngOnInit(): void {
  }

  public listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
      /* detect viewport change and update assignment URL */
      this.setURL();
    });
    this.store.select(ReportState).subscribe((report: ReportStateModel) => {
      this.report = report;
    });
    this.store.select(ReportState.getReportUrl).subscribe(url => {
      LogService.writeLog(`Report url is changed ${url}`, LogLevel.INFO, LogResource.ASSIGNMENT);
      this.setURL();
    });
  }

  public reportLoadedHandler(): void {
    setTimeout(() => {
      if (!this.report.isFrameLoaded && this.url !== '') {
        this.store.dispatch(new ReportAction.SetFrameIsLoaded());
      }
    }, 2000);
  }

  public setURL(): void {
    /* do nothing if Iframe is fully loaded */
    if (!this.report?.isFrameLoaded) {

      if (this.classroom.selectedBoardTab === ViewportTab.REPORT) { /* set report URL, if switched to report and Iframe is not fully loaded */
        this.url = this.report?.url;
      } else { /* drop Iframe, if switched from report and Iframe is not fully loaded */
        this.url = '';
      }
      /* set safe URL to bind to HTML */
      this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  }
}
